import { formatCompactNumber } from "@/utils/formatCompactNumber";

export const formatTick = (value: unknown): string => {
  return formatCompactNumber(value);
};
